import { useEffect, useSyncExternalStore } from "react";

// Stato globale di Ai VESTA vocale (sopravvive al cambio pagina) e scheda che l'utente sta guardando
let open = false;
let seed = null;
const subs = new Set();
const emit = () => subs.forEach((f) => f());
export const takeSeed = () => { const s = seed; seed = null; return s; };
export const voiceStore = {
  open: (s) => {
    seed = typeof s === "string" ? s : null;
    if (open && seed) { open = false; emit(); setTimeout(() => { open = true; emit(); }, 60); return; }
    open = true; emit();
  },
  close: () => { open = false; emit(); },
};
export const useVoiceOpen = () => useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => open);

let view = null;
export const getView = () => view;
export const useVestaView = (active, v) => {
  const k = active ? JSON.stringify(v) : "";
  useEffect(() => {
    if (!k) return undefined;
    const mine = JSON.parse(k);
    view = mine;
    return () => { if (view === mine) view = null; };
  }, [k]);
};
